import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AppComponent } from '../../app.component';
import { MenuAdminComponent } from '../menu-admin/menu-admin.component';
import { FirebaseFunctionsService } from '../../services/firebase-functions.service';
import { AuthServicesService } from '../../services/auth-services.service';

@Component({
  selector: 'app-evenements',
  templateUrl: './evenements.component.html',
  styleUrls: ['./evenements.component.scss']
})
export class EvenementsComponent implements OnInit {

  userData: any = {};
  imgUrl: Observable<any>;
  userTempsFort: any;
  eventName: string = '';
  dateDebut: string = '';
  dateFin: string = '';
  
  constructor(private app: AppComponent, private afs: FirebaseFunctionsService, private authService: AuthServicesService) {
    this.getUserData();
  }

  ngOnInit(): void {
    setTimeout(this.app.afficherPage, 2000);
    const debut = (document.querySelector('.admin_event_debut') as HTMLInputElement);
    debut.value = new Date().toLocaleDateString();
    const fin = (document.querySelector('.admin_event_fin') as HTMLInputElement);
    const finDateTemp = new Date();
    fin.value = finDateTemp.setDate(finDateTemp.getDate() + 1).toLocaleString();
  }
  getUserData(){
    const uid = sessionStorage.getItem('userId');
    if(uid!=null){
      this.afs.getUtilisateur(uid).forEach( user => {
        this.userData = user;
        this.afs.getProfilePicture(uid).subscribe( imgs => {
          this.afs.getImgUrlFromFireStorage(`/utilisateurs/${uid}/profilePicture/${imgs.items[0]['name']}`).subscribe( url => {
            this.imgUrl = (url);
          })
        });
      });
      this.afs.getUserStarTemps(uid).subscribe( temps => {
        this.userTempsFort = temps;
      });
    }else{
      this.go('/');
    }
  }
  manageDropDown(): void {
    const dorpDownDiv = document.querySelector('.menu_dropdown') as HTMLElement;
    dorpDownDiv.style.display = (dorpDownDiv.style.display == 'block') ? 'none' : 'block';
  }
  manageEventModal(){
    let modalState = (document.querySelector('.eventConfModal_ctn') as HTMLElement);
    modalState.style.display = (modalState.style.display === 'none') ? 'flex': 'none';
  }
  go(url:string){
    this.app.navigateTo(url);
  }
  validateEventName(){
    if(this.eventName == ''){
      this.afs.showMessage(3, 'Veuillez entrer un nom pour l\'évènement.', 3000);
      return false;
    }else return true;
  }
  validateEventDate(){
    const dateDebutDate = new Date(this.dateDebut + 'T00:00:00');
    const dateFinDate = new Date(this.dateFin + 'T00:00:00');
    const today = new Date();
    if(this.dateDebut == '' || this.dateFin == ''){
      this.afs.showMessage(3, 'Veuillez vous assurer d\'avoir entrer la date du début ou de la fin de l\'évènement.', 3000);
      return false;
    }else if( dateDebutDate >= dateFinDate ){
      this.afs.showMessage(3, 'La date de fin de l\'évènement doit être supérieur à la date de début d\'au moins 1 jour.', 5000);
      return false;
    }else if( dateDebutDate <= today){
      this.afs.showMessage(3, 'La date de début de l\'évènement doit être supérieur à aujourd\'hui', 3000);
      return false;
    }else{
      return true;
    }
  }
  createEvents(){
    if(this.validateEventName() == true && this.validateEventDate () == true){
      this.afs.getAllEvents().subscribe(events => {
        let check = true;
        let count = 1;
        events.forEach(event => {
          const dateDebut = new Date(event.data()['dateStart'].toDate()).toLocaleDateString();
          const dateEntreeDebut = new Date(this.dateDebut + 'T00:00:00').toLocaleDateString();
          const dateEntreeFin = new Date(this.dateFin + 'T00:00:00').toLocaleDateString();
          const dateFin = new Date(event.data()['dateEnd'].toDate()).toLocaleDateString();
          if(dateEntreeDebut >= dateDebut && dateEntreeDebut <= dateFin){
            check = false;
          }else if(dateDebut >= dateEntreeDebut && dateDebut <= dateEntreeFin){
            check = false
          }
          if(count >= (events.size)){
            if(check){
              this.manageEventModal();
            }else{
              this.app.showMessage(3,'Veuillez choisir une période ne se déroulant pas au millieu d\'un autre évènement',5000);
            }
          }
          count++;
        });
      });
    }
  }
  create(){
    const uid = sessionStorage.getItem('userId');
    const dateDebutDate = new Date(this.dateDebut + 'T00:00:00');
    const dateFinDate = new Date(this.dateFin + 'T00:00:00');
    this.afs.createEvents(uid,dateDebutDate,dateFinDate,this.eventName);
    this.dateDebut = ''; this.dateFin = '';
    this.eventName = '';
    this.manageEventModal();
  }
  signOut(){
    this.authService.signOut();
  }
}
